export default {
  en: {
    websocket: {
      connectionlost: 'The websocket connection is trying to reconnect.<br><br>This happens due to updates or inactivity on your side.<br><br>If this message disappears, the connection is restored.',
      connectionrestored: 'The websocket connection has been restored.',
    }
  },
  de: {
    websocket: {
      connectionlost: 'Die Websocket-Verbindung versucht, die Verbindung wiederherzustellen.<br><br>Dies geschieht aufgrund von Updates oder Inaktivität deinerseits.<br><br>Wenn diese Nachricht verschwindet, ist die Verbindung wiederhergestellt.',
      connectionrestored: 'Die Websocket-Verbindung wurde wiederhergestellt.',
    }
  },
  es: {
    websocket: {
      connectionlost: 'La conexión websocket está intentando reconectarse.<br><br>Esto sucede debido a actualizaciones o inactividad de tu parte.<br><br>Si este mensaje desaparece, la conexión se restaura.',
      connectionrestored: 'La conexión websocket ha sido restaurada.',
    }
  },
  uk: {
    websocket: {
      connectionlost: 'З\'єднання WebSocket намагається відновити з\'єднання.<br><br>Це відбувається через оновлення або неактивність з вашого боку.<br><br>Якщо це повідомлення зникне, з\'єднання буде відновлено.',
      connectionrestored: 'З\'єднання WebSocket було відновлено.',
    }
  },
}
